import type { Me } from '../api/client'

const longDate = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/London' })

// deletesOn is the day her data goes, if her account is closing.
export function deletesOn(me: Me | null): string | null {
  const from = me?.closure?.deletes_from
  return from ? longDate.format(new Date(from)) : null
}
